// import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./profile.css";

// const MyProfile = () => {
//   const [edit, setEdit] = useState(false);

//   const [profile, setProfile] = useState({
//     fullName: "Prachi Shrivastava",
//     username: "prachi_shri",
//     email: "frt.dev2@vmdlab.com",
//     phone: "9876543210",
//     role: "Admin",
//     status: "Active",
//     photo: "https://api.dicebear.com/7.x/adventurer/svg?seed=Rahul"
//   });

//   const handleChange = (e) => {
//     setProfile({ ...profile, [e.target.name]: e.target.value });
//   };

//   return (
//     <div className="profile-page">
//       <div className="container py-5">
//         <div className="profile-card p-4">

//           <div className="row">

//             {/* Left */}
//             <div className="col-md-4 text-center border-end">
//               <img
//                 src={profile.photo}
//                 alt="profile"
//                 className="profile-img mb-3"
//               />
//               <h5>{profile.fullName}</h5>
//               <p className="text-muted">{profile.role}</p>

//               {edit && (
//                 <input type="file" className="form-control mt-2" />
//               )}
//             </div>

//             {/* Right */}
//             <div className="col-md-8 mt-4 mt-md-0">
//               <h5 className="mb-4">My Profile</h5>

//               <div className="row">
//                 <div className="col-md-6 mb-3">
//                   <label>Full Name</label>
//                   <input
//                     type="text"
//                     name="fullName"
//                     className="form-control"
//                     value={profile.fullName}
//                     disabled={!edit}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="col-md-6 mb-3">
//                   <label>Username</label>
//                   <input
//                     type="text"
//                     name="username"
//                     className="form-control"
//                     value={profile.username}
//                     disabled={!edit}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="col-md-6 mb-3">
//                   <label>Email</label>
//                   <input
//                     type="email"
//                     name="email"
//                     className="form-control"
//                     value={profile.email}
//                     disabled={!edit}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="col-md-6 mb-3">
//                   <label>Phone</label>
//                   <input
//                     type="text"
//                     name="phone"
//                     className="form-control"
//                     value={profile.phone}
//                     disabled={!edit}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="col-md-6 mb-3">
//                   <label>Role</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={profile.role}
//                     disabled
//                   />
//                 </div>

//                 <div className="col-md-6 mb-3">
//                   <label>Status</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={profile.status}
//                     disabled
//                   />
//                 </div>
//               </div>

//               <div className="text-end">
//                 {!edit ? (
//                   <button
//                     className="btn btn-dark"
//                     onClick={() => setEdit(true)}
//                   >
//                     Edit
//                   </button>
//                 ) : (
//                   <button
//                     className="btn btn-success"
//                     onClick={() => setEdit(false)}
//                   >
//                     Save
//                   </button>
//                 )}
//               </div>
//             </div>

//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default MyProfile;

import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./profile.css";

const MyProfile = () => {
  const [edit, setEdit] = useState(false);

  const [profile, setProfile] = useState({
    fullName: "Prachi Shrivastava",
    username: "prachi_shri",
    email: "frt.dev2@vmdlab.com",
    phone: "9876543210",
    role: "Admin",
    status: "Active",
    photo: "https://api.dicebear.com/7.x/adventurer/svg?seed=Rahul",
  });

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  return (
    <div className="profile-page">
      <div className="container py-5">
        <div className="profile-card p-4">
          <div className="row">
            {/* Left */}
            <div className="col-md-4 text-center border-end">
              <img
                src={profile.photo}
                alt="profile"
                className="profile-img mb-3"
              />
              <h5>{profile.fullName}</h5>
              <p className="text-muted">{profile.role}</p>

              <input type="file" className="form-control mt-2" />
            </div>

            {/* Right */}
            <div className="col-md-8 mt-4 mt-md-0">
              <h5 className="mb-4">My Profile</h5>

              <div className="row">
                {/* Full Name */}
                <div className="col-md-6 mb-3">
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="fullName"
                    className="form-control"
                    value={profile.fullName}
                    disabled
                  />
                </div>

                {/* Username */}
                <div className="col-md-6 mb-3">
                  <label>Username</label>
                  <input
                    type="text"
                    name="username"
                    className="form-control"
                    value={profile.username}
                    disabled
                  />
                </div>

                {/* Email */}
                <div className="col-md-6 mb-3">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={profile.email}
                    disabled
                  />
                </div>

                {/* Phone (ONLY EDITABLE FIELD) */}
                <div className="col-md-6 mb-3">
                  <label>Phone</label>
                  <input
                    type="text"
                    name="phone"
                    className="form-control"
                    value={profile.phone}
                    disabled={!edit}
                    onChange={handleChange}
                  />
                </div>

                {/* Role */}
                <div className="col-md-6 mb-3">
                  <label>Role</label>
                  <input
                    type="text"
                    className="form-control"
                    value={profile.role}
                    disabled
                  />
                </div>

                {/* Status */}
                <div className="col-md-6 mb-3">
                  <label>Status</label>
                  <input
                    type="text"
                    className="form-control"
                    value={profile.status}
                    disabled
                  />
                </div>
              </div>

              <div className="text-end">
                {!edit ? (
                  <button
                    className="btn btn-dark"
                    onClick={() => setEdit(true)}
                  >
                    Edit
                  </button>
                ) : (
                  <button
                    className="btn btn-success"
                    onClick={() => setEdit(false)}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
